'use client';

// Modules
import React from 'react';
import { useSelector } from 'react-redux';
import Link from 'next/link';

// Material-UI
import Grid from '@mui/material/Grid2';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// Helpers
import { LOCALE_FIN } from '@/lib/helpers';
import { PrimaryButton } from '@/lib/components/Common/Buttons';
import { getBackToAppUrl } from '@/lib/helpers/user';
import { useAppSelector } from '@/lib/redux/hooks';

// Components

type ReduxState = {
  user: {
    activeService: string;
    activeChain: string;
    user: {
      services: string[];
    };
  };
};

export default function FourOhFour() {
  const userState = useAppSelector((state) => state.user);
  const { activeService, activeChain, user } = userState || {};

  if (!user) {
    return null;
  }

  const backLink = getBackToAppUrl(activeService, activeChain, user) || '/';

  return (
    <Container maxWidth="sm">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          height: '100vh',
          textAlign: 'center',
        }}
      >
        <Grid container direction="column">
          <Typography
            variant="h1"
            component="h1"
            gutterBottom
            sx={{ fontWeight: 'bold', fontSize: '6rem' }}
          >
            404
          </Typography>
          <Typography variant="h4" gutterBottom>
            {LOCALE_FIN.PAGE_NOT_FOUND}
          </Typography>
          <Box>
            <PrimaryButton component={Link} href={backLink} size="large">
              {LOCALE_FIN.BACK_HOME}
            </PrimaryButton>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
